import { ENGLISH_MATCHES_WITH_SPACE, NUMBERS_MATCHES } from '@uplift/constants';
import { l10nEnService } from '@uplift/services';
import { AddressType } from '@uplift/types';
import * as Yup from 'yup';

export type SettingsAddressValidationRequiredMessages = Partial<Omit<Record<keyof AddressType, string>, 'address2'>>;

export const settingsAddressValidation = (l10n: typeof l10nEnService, requiredMessages?: SettingsAddressValidationRequiredMessages) => Yup.object({
  address1: Yup.string()
    .matches(ENGLISH_MATCHES_WITH_SPACE, { message: l10n.validations.couldContainEnglishWithSpace, excludeEmptyString: true })
    .max(50, l10n.validations.client.address.line1TooLong)
    .required(requiredMessages?.address1 ?? l10n.validations.client.address.line1Empty),
  address2: Yup.string()
    .matches(ENGLISH_MATCHES_WITH_SPACE, { message: l10n.validations.couldContainEnglishWithSpace, excludeEmptyString: true })
    .max(50, l10n.validations.client.address.line1TooLong),
  city: Yup.string()
    .matches(ENGLISH_MATCHES_WITH_SPACE, l10n.validations.couldContainEnglishWithSpace)
    .max(50, l10n.validations.client.address.cityTooLong)
    .required(requiredMessages?.city ?? l10n.validations.client.address.cityEmpty),
  state: Yup.string()
    .nullable()
    .required(requiredMessages?.state ?? l10n.validations.client.address.state),
  zip: Yup.string()
    .matches(NUMBERS_MATCHES, l10n.validations.digitsOnly)
    .min(5, requiredMessages?.zip ?? l10n.validations.client.address.zipEmpty)
    .max(5, requiredMessages?.zip ?? l10n.validations.client.address.zipEmpty)
    .required(requiredMessages?.zip ?? l10n.validations.client.address.zipEmpty)
});
